import { planTypeFromCode } from '@/core/analytics/plan-type'

// Kept off analytics.ts so the nav that sets it leaves the deck engine lazy.

// Active FLOW plan's type, attached to every day-flow event so metrics can be
// split per plan. Canonical values MATCH journey analytics (vgn | lmp | taiChi |
// tns | kds | hpm) so cross-feature funnels line up.
let planType: string | null = null

export function setDayFlowAnalyticsPlanType(code: string | null | undefined) {
  planType = code ? planTypeFromCode(code) : null
}

// Current canonical plan type, for events tracked outside this module (e.g. the
// survey flow hosted by flow-practice).
export function getDayFlowAnalyticsPlanType(): string | null {
  return planType
}
